@if (accounts.length > 0) {
  <div ngbDropdown display="dynamic" placement="bottom-right">
    <button class="btn bg-transparent" id="select_tenant_dropdown" ngbDropdownToggle>
      <span class="">{{ tenant.name }}</span>
    </button>
    <div ngbDropdownMenu aria-labelledby="select_tenant_dropdown">
      @for (t of accounts; track t) {
        <button class="dropdown-item" (click)="selectTenant(t.tenant.id)">
          <span>{{ t.tenant.name }}</span>
        </button>
      }
    </div>
  </div>
}
